module.exports = __webpack_public_path__ + "static/img/13.c5be7870.png";